import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const PumpingStationMasterTableDataAPI = createAsyncThunk("PumpingStationMasterTableData", async ({ data }) => {
    const {
        M_SW_PumpingStationWisePumpSetDetailsID,
        M_WardID,
        M_SW_PumpingStationID,
        PumpSetDetails,
        M_UserID,
        token,
        From,
        To,
        handlePumpingStationMasterExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_SW_PumpingStationWisePumpSetDetails_Select?M_SW_PumpingStationWisePumpSetDetailsID=${M_SW_PumpingStationWisePumpSetDetailsID}&M_WardID=${M_WardID ? M_WardID : '0'}&M_SW_PumpingStationID=${M_SW_PumpingStationID ? M_SW_PumpingStationID : '0'}&PumpSetDetails=${PumpSetDetails ? PumpSetDetails : ''}&M_UserID=${M_UserID}&FromTop=${From}&ToTop=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handlePumpingStationMasterExport && handlePumpingStationMasterExport()
                return result.data
            } else {
                return result
            }
        })
})

const PumpingStationMasterTableDataSlice = createSlice({
    name: "PumpingStationMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PumpingStationMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PumpingStationMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PumpingStationMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PumpingStationMasterTableDataReducer = PumpingStationMasterTableDataSlice.reducer

export const PumpingStationMasterExportTableDataAPI = createAsyncThunk("PumpingStationMasterExportTableData", async ({ data }) => {
    const {
        M_SW_PumpingStationWisePumpSetDetailsID,
        M_WardID,
        M_SW_PumpingStationID,
        PumpSetDetails,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_SW_PumpingStationWisePumpSetDetails_Select?M_SW_PumpingStationWisePumpSetDetailsID=${M_SW_PumpingStationWisePumpSetDetailsID}&M_WardID=${M_WardID ? M_WardID : '0'}&M_SW_PumpingStationID=${M_SW_PumpingStationID ? M_SW_PumpingStationID : '0'}&PumpSetDetails=${PumpSetDetails ? PumpSetDetails : ''}&M_UserID=${M_UserID}&FromTop=${From}&ToTop=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PumpingStationMasterExportTableDataSlice = createSlice({
    name: "PumpingStationMasterExportTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PumpingStationMasterExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(PumpingStationMasterExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(PumpingStationMasterExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PumpingStationMasterExportTableDataReducer = PumpingStationMasterExportTableDataSlice.reducer


export const PumpingStationMasterPostDataAPI = createAsyncThunk("PumpingStationPostData", async ({ data }) => {
    const {
        M_SW_PumpingStationWisePumpSetDetailsID,
        M_SW_PumpingStationID,
        PumpSetDetails,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_SW_PumpingStationWisePumpSetDetailsID", M_SW_PumpingStationWisePumpSetDetailsID);
    formdata.append("M_SW_PumpingStationID", M_SW_PumpingStationID);
    formdata.append("PumpSetDetails", PumpSetDetails);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_SW_PumpingStationWisePumpSetDetails_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const PumpingStationMasterPostDataSlice = createSlice({
    name: "PumpingStationMasterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PumpingStationMasterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PumpingStationMasterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PumpingStationMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PumpingStationMasterPostDataReducer = PumpingStationMasterPostDataSlice.reducer

// -----------------Delete API ---------------

export const PumpingStationMasterDeleteAPI = createAsyncThunk("PumpingStationMasterDelete", async ({ data }) => {
    const {
        M_SW_PumpingStationWisePumpSetDetailsID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_SW_PumpingStationWisePumpSetDetailsID", M_SW_PumpingStationWisePumpSetDetailsID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_SW_PumpingStationWisePumpSetDetails_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const PumpingStationMasterDeleteSlice = createSlice({
    name: "PumpingStationMasterDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PumpingStationMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PumpingStationMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(PumpingStationMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PumpingStationMasterDeleteReducer = PumpingStationMasterDeleteSlice.reducer